/**
 * Interfeys tarjimasi (MultiLang_TZ §8.4, §8.5, §8.6).
 *
 * NEGA KUTUBXONA OLINMADI. Bandl hozir 65 kB gzip va Mini App ko'pincha
 * sekin mobil internetda ochiladi. `i18next` + react bog'lovchisi ~30 kB
 * qo'shadi — React 19 ning +14.6 kB idan voz kechgan joyda bu mantiqsiz.
 * Bizga kerak bo'lgan hamma narsa 60 qatorga sig'adi.
 *
 * KO'PLIK — `Intl.PluralRules`. Brauzerda tayyor turadi, bandlga bir
 * bayt ham qo'shmaydi va har bir til uchun TO'G'RI ishlaydi. Qo'lda
 * yozilgan rus qoidalari deyarli har doim 21 va 101 da xato qiladi:
 *
 *     1 -> one    2 -> few    5 -> many    21 -> ONE    101 -> ONE
 *
 * SANA — `Intl.DateTimeFormat`. Qo'lda yozilgan oy nomlari ro'yxati har
 * bir til uchun takrorlanishi kerak bo'lardi.
 */

import { uz, type Dict, type Key } from "./uz.ts";

// Faol til va lug'at. Modul darajasida saqlanadi: til bir marta,
// ishga tushganda o'rnatiladi va keyin o'zgarmaydi (o'zgarsa ilova
// qayta yuklanadi — bu Mini App uchun maqbul va kodni ancha soddalashtiradi).
let currentLang = "uz";
let dict: Dict = uz;

// Faqat FAOL til yuklanadi. To'rt tilning hammasini bandlga solish har
// bir foydalanuvchiga kerak bo'lmagan uchtasini yuklatish demakdir.
const LOADERS: Record<string, () => Promise<{ default: Dict }>> = {
  uz: async () => ({ default: uz }),
  // `import()` ATAYLAB: rus lug'ati alohida bo'lakka chiqadi va uni
  // faqat rus tilini tanlagan foydalanuvchi yuklaydi.
  ru: () => import("./ru.ts").then((m) => ({ default: m.ru })),
  en: () => import("./en.ts").then((m) => ({ default: m.en })),
  hi: () => import("./hi.ts").then((m) => ({ default: m.hi })),
  // Yangi til qo'shilganda shu yerga bitta qator. Fayl `uz.ts` bilan
  // BIR XIL kalitlarga ega bo'lishi shart — aks holda TypeScript aytadi.
};

// Oxirgi ma'lum til — BIRINCHI KADR uchun. `/api/me` kelguncha til
// noma'lum, bayram foni esa birinchi kadrdayoq qo'yilishi kerak (aks
// holda fon ko'z oldida almashadi). Shu yerda saqlanmasa rus
// foydalanuvchisi har ochilishda bir zum o'zbek bayrami fonini ko'rardi.
const LANG_KEY = "gs.lang";

export function lastLang(): string {
  try {
    return localStorage.getItem(LANG_KEY) || "uz";
  } catch {
    return "uz";            // node testi, bloklangan saqlash, maxfiy oyna
  }
}

export async function setLang(lang: string): Promise<void> {
  const load = LOADERS[lang];
  if (!load) {
    // Noma'lum til — manba tilida qolamiz. Bu jimgina degradatsiya
    // EMAS: reyestr yoqilmagan tilni bermaydi, bu yerga tushish
    // sozlama xatosi va u konsolda ko'rinishi kerak.
    console.warn(`i18n: '${lang}' uchun lug'at yo'q, 'uz' qoldi`);
    return;
  }
  dict = (await load()).default;
  currentLang = lang;
  try {
    localStorage.setItem(LANG_KEY, lang);
  } catch {
    /* saqlab bo'lmasa — keyingi ochilishda bir zum `uz` foni, xolos */
  }
}

export function getLang(): string {
  return currentLang;
}

/** Tarjima. `{n}`, `{text}` kabi o'rinbosarlar almashtiriladi. */
export function t(key: Key, vars?: Record<string, string | number>): string {
  let out: string = dict[key] ?? uz[key] ?? key;
  if (vars) {
    for (const [name, value] of Object.entries(vars)) {
      out = out.split(`{${name}}`).join(String(value));
    }
  }
  return out;
}

/**
 * Taksonomiya qiymati uchun yorliq — DINAMIK kalit bilan.
 *
 * `t()` kalitni tip darajasida tekshiradi va bu to'g'ri: ekran matni
 * qo'lda yoziladi, ya'ni xatoni kompilyator tutishi kerak. Taksonomiya
 * esa BOSHQACHA — qiymat serverdan keladi (`funding: "full"`) va uni
 * tipga aylantirib bo'lmaydi.
 *
 * NOMA'LUM QIYMAT UCHUN KALIT EMAS, QIYMATNING O'ZI qaytadi. Bazaga
 * yangi toifa qo'shilib, lug'atga yozilmasa, foydalanuvchi `full`
 * kabi so'zni ko'radi — bu chirkin, lekin `funding.full` degan
 * ichki kalitdan ancha yaxshi va nima yetishmayotganini aytadi.
 */
export function tx(prefix: string, value: string | null | undefined): string {
  if (!value) return "";
  const key = `${prefix}.${value}` as Key;
  return key in dict || key in uz ? t(key) : value;
}

/**
 * Ko'plik shakli bilan tarjima.
 *
 * `base` — `#` gacha bo'lgan qism. Kerakli shaklni `Intl` tanlaydi;
 * agar o'sha shakl lug'atda bo'lmasa `other` ga tushadi.
 */
export function tp(base: string, n: number,
                   vars?: Record<string, string | number>): string {
  const form = new Intl.PluralRules(currentLang).select(n);
  const key = (`${base}#${form}` in dict ? `${base}#${form}` : `${base}#other`) as Key;
  return t(key, { n, ...vars });
}

/** "2026-10-06" -> faol tildagi sana. */
export function formatDate(iso: string | null): string {
  if (!iso) return t("date.unknown");
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!match) return iso;
  const [, y, m, d] = match;
  // `Date.UTC` ATAYLAB: mahalliy vaqt mintaqasida `new Date("2026-10-06")`
  // ba'zi mintaqalarda bir kun oldingi sanani beradi.
  const date = new Date(Date.UTC(Number(y), Number(m) - 1, Number(d)));
  return new Intl.DateTimeFormat(currentLang, {
    day: "numeric", month: "long", year: "numeric", timeZone: "UTC",
  }).format(date);
}

/** Deadline'gacha qolgan vaqt. */
export function daysLeftLabel(days: number | null): string | null {
  if (days === null) return null;
  if (days < 0) return t("days.past");
  if (days === 0) return t("days.today");
  if (days <= 30) return tp("days.left", days);
  return tp("months.left", Math.round(days / 30));
}
